import { useRootPageLinkForm } from '@/hooks/useRootPageLinkForm';
import EventSummary from '@/types/EventSummary';
import IRootPage from '@/types/IRootPage';
import IRootPageLink from '@/types/IRootPageLink';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IUseAddLinkModal {
	close: () => void;
	onLinkAdded: (link: IRootPageLink) => Promise<void>;
}

export default function useAddLinkModal(args: IUseAddLinkModal) {
	const { t } = useTranslation();

	// Used by the service tab
	const [service, setService] = useState<EventSummary | null>(null);
	// Used by the root page tab
	const [rootPage, setRootPage] = useState<IRootPage | null>(null);

	const { form } = useRootPageLinkForm({
		link: {
			description: '',
			link: '',
			name: '',
			imageUrl: '',
		},
	});

	/**
	 * Callback executed every time something in the question is changed.
	 */
	const handleSubmit = form.handleSubmit((v) => {
		return args.onLinkAdded(v).then(() => {
			form.reset();
			args.close();
		});
	});

	function handleClose() {
		form.reset();
		setService(null);
		setRootPage(null);
	}

	return {
		handleClose,
		setService,
		setRootPage,
		submitForm: () => handleSubmit(),
		t,
		form,
		service,
		rootPage,
	};
}
